import { getPageAllowedRoles } from "../../config/roles";
import { fullWidth } from "../../blocks/layout/columnSpans";
import { PageDefinition } from "../pageDefinition.types";
import { AutomationDashboardPanel } from "./AutomationDashboardPanel";

/** What automations have run and will run next, with the actions on the upcoming sends. */
export const automationDashboardPageDefinition: PageDefinition = {
  path: "/automation-dashboard",
  title: "Automation Dashboard",
  allowedRoles: getPageAllowedRoles("automation-dashboard"),
  rows: [
    {
      id: "row-dashboard",
      panels: [
        {
          id: "panel-dashboard",
          title: "",
          span: fullWidth,
          component: AutomationDashboardPanel,
          plain: true,
        },
      ],
    },
  ],
};
